// extracted by mini-css-extract-plugin
export default {"container":"planet__container__Kk5jl","planet":"planet__planet__ArODR"};